import { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft, FaLayerGroup, FaCalendarAlt, FaUsers, FaUserFriends, FaMapMarkerAlt, FaMapMarkedAlt, FaChild, FaBroom, FaMusic, FaVideo, FaTags, FaHandshake } from "react-icons/fa";
import CatalogoTable from "../components/admin/CatalogoTable";
import ClasesDominicalAdmin from "../components/admin/ClasesDominicalAdmin";

const CATALOGOS = [
  { tabla: "servicios", nombre: "Servicios", nombreSingular: "servicio", descripcion: "Catálogo de servicios y cultos de la iglesia.", icono: FaCalendarAlt },
  { tabla: "clubs", nombre: "Clubs", nombreSingular: "club", descripcion: "Catálogo de clubs bíblicos de la iglesia.", icono: FaUsers },
  { tabla: "miembros_club", nombre: "Miembros de Club", nombreSingular: "miembro", descripcion: "Relación de miembros inscritos en cada club.", icono: FaUserFriends },
  { tabla: "estados", nombre: "Estados", nombreSingular: "estado", descripcion: "Catálogo de estados utilizados en direcciones.", icono: FaMapMarkerAlt },
  { tabla: "municipios", nombre: "Municipios", nombreSingular: "municipio", descripcion: "Catálogo de municipios relacionados a un estado.", icono: FaMapMarkedAlt },
  { tabla: "colonias", nombre: "Colonias", nombreSingular: "colonia", descripcion: "Catálogo de colonias utilizadas en direcciones.", icono: FaMapMarkerAlt },
  { tabla: "clases_dominical", nombre: "Clases Dominicales", nombreSingular: "clase", descripcion: "Clases o grupos de Escuela Dominical.", icono: FaChild },
  { tabla: "lista_aseo", nombre: "Lista de Aseo", nombreSingular: "registro", descripcion: "Rotación de familias y hermanos responsables del aseo.", icono: FaBroom },
  { tabla: "directores_musica", nombre: "Directores de Música", nombreSingular: "director", descripcion: "Catálogo de miembros que fungen como directores de música.", icono: FaMusic },
  { tabla: "proyeccion", nombre: "Proyección", nombreSingular: "registro", descripcion: "Catálogo de miembros que fungen en proyección durante los servicios.", icono: FaVideo },
  { tabla: "tipos_reunion", nombre: "Tipos de Reunión", nombreSingular: "tipo", descripcion: "Tipos de reunión del módulo Reuniones. \"Registra en Miembros\" indica si el tipo lleva a una persona (bautizada, aceptada...) y qué fecha se guarda en su ficha.", icono: FaHandshake },
  { tabla: "categorias_salida", nombre: "Categorías de Salidas", nombreSingular: "categoría", descripcion: "Categorías para clasificar las salidas de dinero de Tesorería.", icono: FaTags },
];

export default function CatalogosAdmin() {
  const [seleccionado, setSeleccionado] = useState(null);

  if (seleccionado?.tabla === "clases_dominical") {
    return <ClasesDominicalAdmin onBack={() => setSeleccionado(null)} />;
  }

  if (seleccionado) {
    return (
      <div className="bg-slate-50">
        <CatalogoTable
          tabla={seleccionado.tabla}
          nombre={seleccionado.nombre}
          nombreSingular={seleccionado.nombreSingular}
          descripcion={seleccionado.descripcion}
          icono={seleccionado.icono}
          onBack={() => setSeleccionado(null)}
        />
      </div>
    );
  }

  return (
    <div className="p-6 bg-slate-50">

      <div className="mb-6">
        <Link to="/dashboard/administracion" className="text-sm text-slate-500 hover:text-indigo-600 flex items-center gap-1 mb-1">
          <FaArrowLeft className="text-xs" /> Administración
        </Link>
        <h1 className="text-2xl font-bold text-slate-800">Catálogos</h1>
        <p className="text-sm text-slate-500">Administra los catálogos generales utilizados en todo el sistema.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CATALOGOS.map((c) => {
          const Icono = c.icono || FaLayerGroup;
          return (
            <button
              key={c.tabla}
              onClick={() => setSeleccionado(c)}
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 text-left hover:border-indigo-300 hover:shadow-md transition group"
            >
              <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center mb-3 group-hover:bg-indigo-600 group-hover:text-white transition">
                <Icono />
              </div>
              <p className="font-semibold text-sm text-slate-800">{c.nombre}</p>
              <p className="text-xs text-slate-400 mt-0.5">Ver y administrar registros</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
